import { render, staticRenderFns } from "./InstanceAvatar.vue?vue&type=template&id=1b2a6a62&scoped=true"
import script from "./InstanceAvatar.vue?vue&type=script&lang=js"
export * from "./InstanceAvatar.vue?vue&type=script&lang=js"
import style0 from "./InstanceAvatar.vue?vue&type=style&index=0&id=1b2a6a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a6a62",
  null
  
)

export default component.exports